import { useCreateDatasetGroup } from "api/api-hooks/dataset-groups-hooks";
import { T } from "services/lang/LanguageService";
import { GroupButtonProps } from "api/model/dataset/datasetGroups";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useState } from "react";
import TitleForm from "./TitleForm";

const AddSubgroupButton: React.FC<GroupButtonProps> = ({ group }) => {
  const [title, setTitle] = useState<string>("");
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const { mutateAsync } = useCreateDatasetGroup();

  const addSubgroup = async () => {
   await mutateAsync({ title, parentId: group!.id });
    setDialogOpen(false);
    setTitle("");
  }

  return (
    <>
      <Dialog visible={dialogOpen} onHide={() => setDialogOpen(false)} header={T("action.add-subgroup")}>
        <TitleForm
          title={title}
          setTitle={setTitle}
          buttonLabel={T("action.create")}
          buttonColor="success"
          onCancel={() => setDialogOpen(false)}
          onAccept={addSubgroup}
        />
      </Dialog>
      <Button
        label={T("action.add-subgroup")}
        icon="pi pi-plus"
        onClick={() => setDialogOpen(true)}
        className="p-button-success p-mr-2"
        disabled={!group}
      />
    </>
  );
}

export default AddSubgroupButton;